export default __webpack_public_path__ + "static/media/person_3@2x.5bc67212.png";